import { useStrategyStore } from '../../../store/strategy-store/strategy-store';
import { Filters as FiltersCost } from './cost-tab/filters/filters';
import { Filters as FiltersFlowByPhase } from './flow-by-phase-tab/filters/filters';
import { Filters as FiltersFocus } from './focus-tab/filters/filters';
import { PerformanceTab } from './initiative-performance.type';
import { Filters as FiltersMilestones } from './milestones-tab/filters/filters';
import { Filters as FiltersRelatedTasks } from './related-tasks-tab/filters/filters';
import { Filters as FiltersTargets } from './targets-tab/filters/filters';
import { Filters as FiltersThroughput } from './throughput-tab/filters/filters';

export const InitiativePerformanceFilters = ({ setShow }: { setShow: (show: boolean) => void }) => {
  const performanceTab = useStrategyStore((state) => state.performanceTab);

  switch (performanceTab) {
    case PerformanceTab.Throughput:
      return <FiltersThroughput setShow={setShow} />;
    case PerformanceTab.Focus:
      return <FiltersFocus setShow={setShow} />;
    case PerformanceTab.FlowByPhase:
      return <FiltersFlowByPhase setShow={setShow} />;
    case PerformanceTab.Targets:
      return <FiltersTargets setShow={setShow} />;
    case PerformanceTab.Milestones:
      return <FiltersMilestones setShow={setShow} />;
    case PerformanceTab.Cost:
      return <FiltersCost setShow={setShow} />;
    case PerformanceTab.RelatedTasks:
      return <FiltersRelatedTasks setShow={setShow} />;
    default:
      return null;
  }
};
